import axios from 'axios';
import { useEffect, useState } from 'react';

export interface HrUser {
  _id: string;
  name: string;
}

/**
 * The recruiters (role HR), as {_id, name}, for an owner or assignee picker and for showing an
 * owner's name instead of their id.
 *
 * Role HR only: making a Super Admin or a Marketing user the recruiter on a candidate is not a
 * thing. `enabled` lets a caller skip the request on a page that will never show the picker.
 */
export function useHrUsers(enabled = true): HrUser[] {
  const [users, setUsers] = useState<HrUser[]>([]);
  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    axios
      .get('/api/users?page=0&size=200')
      .then((r) => {
        if (cancelled) return;
        const list: any[] = r?.data?.content ?? r?.data ?? [];
        setUsers(
          list
            .filter((u) => u?.role === 'HR')
            .map((u) => ({
              _id: u._id,
              name:
                u?.personalDetails?.fullName
                || [u?.personalDetails?.firstName, u?.personalDetails?.lastName].filter(Boolean).join(' ')
                || u._id,
            })),
        );
      })
      .catch(() => {
        /* names are cosmetic; the id still renders */
      });
    return () => {
      cancelled = true;
    };
  }, [enabled]);
  return users;
}
